import { type WalletType } from '@/entities/user/model/wallet.types';

import { api } from '../../api';

export const withdraw = async (prize: WalletType) => {
  const url = `v1/wallet/withdraw?type=${prize}`;
  try {
    return await api.put(url);
  } catch (err) {
    return console.error(`withdraw ${prize} fail`, err);
  }
};
